import React from 'react';
import { useTheme, useMediaQuery } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import { Box } from "@mui/system";
import CasablancaLogo from '../shared/CasablancaLogo';
import { useConfigurationStore } from '../../stores/ConfigStore';
import { useTenantStore } from '../../stores/TenantStore';
import { useThemeStore } from '../../stores/ThemeStore';

const iconStyle = {
  fontSize: '24px', // Fixed font size for icons
};

const Header = ({ title }: { title: string }) => {
  const { configuration } = useConfigurationStore();
  const { toggleTheme, toggleFontSize } = useThemeStore()
  const theme = useTheme();
  const {activeState} = useTenantStore()

  const isToggleFontSizeVisible = (!useMediaQuery(theme.breakpoints.down('sm')) && activeState.registrationSheetHasArrived);

  const Logo = () => {
    if (configuration.design.showLogo) {
      if (configuration.design.companyLogoUrl) {
        return <img src={configuration.design.companyLogoUrl} alt="Company Logo" height="50" />;
      }else{
        return <CasablancaLogo />
      }
    }else{
      return <Typography variant='h5' fontWeight="bold">{configuration.design.companyName}</Typography>
    }
  }

  return (
    <AppBar
      position="relative"
      className="no-select"
      style={{
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary
      }}
      elevation={2}
      sx={{zIndex: 100}}
    >
      <Toolbar>
        <Logo/>
        <Box
          position="absolute"
          left={0}
          width="100%"
          display="flex"
          justifyContent="center"
        >
          <Typography variant="h5" align="center">
            {title || ""}
          </Typography>
        </Box>

        <Box flexGrow={1} />
        <Box display="flex" alignItems="center" gap={1}>
          {isToggleFontSizeVisible && (
            <IconButton
              edge="end"
              color="inherit"
              onClick={toggleFontSize}
              aria-label="toggle Font Size"
            >
              <FormatSizeIcon style={iconStyle} />
            </IconButton>
          )}
          <IconButton
            edge="end"
            color="inherit"
            onClick={toggleTheme}
            aria-label="toggle theme"
          >
            {theme.palette.mode === "dark" ? (
              <Brightness7Icon style={iconStyle} />
            ) : (
              <Brightness4Icon style={iconStyle} />
            )}
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
